import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import Drawer, { DrawerHeader, DrawerFooter } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { useForm, useActions } from 'utils/hooks';
import * as statusesActions from 'store/statuses/actions';
import { FormBody } from 'common/components/drawer';
import EditVisibilityForm from 'components/drawers/EditCompanyVisibility';
import selectDataFromState from 'utils/selectDataFromState';

import config from './status/config';
import CrewStatuses from './status';

const EditStatuses = ({ drawer, active, editType, refetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateStatuses, createStatuses] = useActions([
    statusesActions.updateStatuses,
    statusesActions.createStatuses
  ]);
  const { formState, loadValues, handleSubmitError, resetForm, collectValues } = useForm(config);
  const { isOpen } = drawer;

  useEffect(() => {
    if (active) {
      const params = {
        ...active
      };

      const initialValues = selectDataFromState(params, config);

      loadValues({ ...initialValues });
    } else if (isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const submit = async () => {
    const values = collectValues();
    if (!values) return;

    const { country, type, ...rest } = values;

    const params = {
      ...rest,
      id: active ? active.id : undefined,
      table: 'crew_statuses'
    };

    setIsSubmitting(true);

    try {
      if (active) {
        await updateStatuses(params);
      } else {
        await createStatuses(params);
        resetForm();
        refetchData();
      }

      drawer.close();
    } catch (error) {
      handleSubmitError(error);
    }

    setIsSubmitting(false);
  };

  return active && editType === 'visibility' ? (
    <EditVisibilityForm
      drawer={drawer}
      active={active}
      isOpen={drawer.isOpen}
      type="enums/crew-statuses"
    />
  ) : (
    <Drawer {...drawer} className="table-drawer">
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit ' + active.name : 'Add New Status'}
      </DrawerHeader>

      <FormDrawer>
        <FormBody>
          <CrewStatuses formState={formState} />
        </FormBody>
      </FormDrawer>

      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => drawer.close()}
          disabled={isSubmitting}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={isSubmitting} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default EditStatuses;
